import React from "react";
import { Typography } from "@mui/material";

const normalizePhaseColour = (value) => {
  if (value === "Green" || value === 1 || value === "1") return 1;
  if (value === "Amber" || value === 2 || value === "2") return 2;
  if (value === "Red" || value === 3 || value === "3") return 3;
  return 1; // default fallback
};

const PhaseColourHelper = ({ phaseColour }) => {
  const colour = normalizePhaseColour(phaseColour);

  let bg, color, label;
  switch (colour) {
    case 1:
      bg = "#e5f9ed";
      color = "#1bc943";
      label = "No Error";
      break;
    case 2:
      bg = "#fff4e5";
      color = "#f7630eff";
      label = "Warning";
      break;
    case 3:
      bg = "#ffe5e5";
      color = "#de1212ff";
      label = "Critical Error";
      break;
    default:
      bg = "#f2f2f2";
      color = "#555";
      label = "Unknown";
      break;
  }

  return (
    <Typography
      variant="body2"
      component="span"
      style={{
        backgroundColor: bg,
        color,
        padding: "2px 8px",
        borderRadius: 6,
        fontWeight: 600,
        whiteSpace: "nowrap",
        textTransform: "capitalize",
      }}
    >
      {label}
    </Typography>
  );
};

export default PhaseColourHelper;
